import { useContext, useCallback } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';

import { ErrorRoles, DocErrors } from './useUploadReducer.ts';

export enum BulkUploadErrors {
	ALL_REJECTED_ERROR = 'ALL_REJECTED_ERROR',
}

export const useHandleRejectedDocuments = (
	setBulkError: (error: string) => void,
): ((response: any, documents: any) => Promise<void>) => {
	const {
		docActions: { uploadDocFailure },
	} = useContext(ImportStateContext);

	return useCallback(
		async (response: any, documents: any) => {
			const rejectedResults = response.filter((item) => item.status === 'rejected');
			if (!rejectedResults.length) return;

			await Promise.allSettled(
				rejectedResults.map(async (res) => {
					const { error } = await res.reason.response.json();
					if (DocErrors[error?.code]) {
						return uploadDocFailure(error.docTitle, {
							type: DocErrors[error.code],
							role: ErrorRoles.ERROR,
						});
					}
					return uploadDocFailure(error.docTitle, {
						type: DocErrors.FAILED_UPLOAD_ERROR,
						role: ErrorRoles.ERROR,
					});
				}),
			);

			if (rejectedResults.length == documents.length) {
				setBulkError(BulkUploadErrors.ALL_REJECTED_ERROR);
				throw BulkUploadErrors.ALL_REJECTED_ERROR;
			}
		},
		[uploadDocFailure, setBulkError],
	);
};
